<template>

  <div ref="cover-container" class="cover-container">
    <div class="wrapper-image"><img class="cover-image d-block d-md-none" :src="article.story.cover_movil"><img class="cover-image d-none d-md-block" :src="article.story.cover"></div>
    <div class="row justify-content-center">
      <div class="col-11 col-sm-11 col-sm-6 col-md-7 align-self-center">
       
        <!-- <p class="d-block d-md-none">{{ article.story.excerpt }}</p> -->
        
        <!-- <div class="cover-social">
          <ShareNetwork
              network="facebook"
              :url="article.story.url"
              :title="`${article.story.title} - ${article.story.excerpt}`"
              :description="article.story.excerpt"
              :quote="article.story.excerpt"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
              <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
            </svg>
          </ShareNetwork>

          <ShareNetwork
              network="twitter"
              :url="article.story.url"
              :title="`${article.story.title} - ${article.story.excerpt}`"
              :description="article.story.excerpt"
              :quote="article.story.excerpt"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-twitter" viewBox="0 0 16 16">
              <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
            </svg>
          </ShareNetwork>
        </div> -->


      </div>
    </div>
  </div>

</template>

<style lang="scss">
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translatey(5vh);
    }

    to {
      opacity: 1;
      transform: translateY(0vh);
    }
  }

  .cover-social {
    margin: 25px auto;
    text-align: right;

    a {
      color: #fff;
      margin-right: 15px;
    }
  }

  .date-published {
    margin: 25px 0;
    font-size: 21px;
    font-family: 'Roboto Condensed', sans-serif;
    text-transform: uppercase;
    color: #ffd26ec7;
  }

  .cover-container {
    position: relative;
    max-width: 100%;
    min-height: 210vh;
    align-items: center;
    margin: 0 auto;
    top: 0vh;
    opacity: 1;
    animation-name: slideUp;
    animation-duration: .75s; /* or: Xms */
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out; /* or: ease, ease-in, ease-in-out, linear, cubic-bezier(x1, y1, x2, y2) */

    @media (max-width: 560px) {
      min-height: 120vh;
    }


    .wrapper-image {
      position: sticky;
      top: 0;
      height: 100vh;

      @media (max-width: 1400px) {
        height: 80vh;
      }
      @media (max-width: 1200px) {
        height: 65vh;
      }

      @media (max-width: 768px) {
        height: 130vh;
      }

      @media (max-width: 560px) {
        height: 100vh;
      }

      @media (max-height: 780px) {
        height: 125vh;
      }
    }
    h1 {
      color: var(--app-yellow);
      font-family: var(--app-header-font);
      font-weight: 700;
      text-align: left;
      line-height: 0.9em;

      @media (max-width: 560px) {
        font-size: 41px;
      }

      @media (max-width: 768px) {
        font-size: 41px;
      }

      @media (max-width: 1900px) {
        font-size: 41px;
      }

      span {
        display: block;
      }

      img {
        width: 100%;
        height: 90vh;
        object-fit: cover;
        object-position: center;
        pointer-events: none;
      }
    }

    p {
      color: #fff;
      text-shadow: 2px 2px 2px rgb(0 0 0 / 60%);
    }

    h2 {
      color: var(--app-white);
      font-family: var(--app-header-font);
      font-size: 41px;
      font-weight: 400;
      text-align: left;

      span {
        display: block;
      }
    }

    .image-wrapper {
      width: 100%;
      pointer-events: none;

      @media (min-width: 900px) {
        position: absolute;
        top: 0;
        height: 250vh;
      }
    }

    .cover-image {
      width: 100%;
      pointer-events: none;

    }
  }

</style>


<script>
  export default {
    name: "CoverStory",
    props: {
      article: Object
    },
    mounted() {
      setTimeout(() => {
        this.$refs['cover-container'].style.opacity=1
      }, 200)
    }
  }
</script>